import { createUseStyles } from 'react-jss'

import { zIndexes } from '../../variables.style'

export const style = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: '0.2',
    backgroundColor: 'black',
    zIndex: zIndexes.dropdownMenuOverlay
  }
}

export const useStyles = createUseStyles(style)
